// extracted by mini-css-extract-plugin
module.exports = {"container":"navigation_container__fk3pm","linksWrapper":"navigation_linksWrapper__DkQcc","title":"navigation_title__7dNzI","description":"navigation_description__MgnCd"};